import React, { useState, useContext } from 'react';
import { Table, Pagination } from 'rsuite';
import './users-list.scss';
import 'rsuite/dist/rsuite.min.css';
import { default as t } from '../../../../utils/i18n';
import { AdminService } from '../../../../services';
import { UserContext } from '../../../../context';

function UsersList({ accounts, changeLimit, changePage, accountId }) {
  const { Column, HeaderCell, Cell } = Table;
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [searchItem, setSearchItem] = useState('');
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;

  const getWidth = (value = 6) => {
    return window.innerWidth / value;
  };

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
    changeLimit(1, searchItem, dataKey);
  };

  const pageChange = page => {
    setPage(page);
    changePage(page, searchItem, limit);
  };

  const StatusCell = ({ rowData, onChange, dataKey, ...props }) => (
    <Cell {...props}>
      <div>
        {rowData[dataKey] === 'ACTIVE' ? (
          <span>{t('admin.status.active')}</span>
        ) : (
          <span>{t('admin.status.inactive')}</span>
        )}
      </div>
    </Cell>
  );

  const onDownloadUsers = async () => {
    try {
      const listResponse = await AdminService.downloadUsers(userAccessToken, username, accountId);
      const addRes = listResponse.data;
      const outputFilename = `users.xlsx`;
      const url = URL.createObjectURL(new Blob([addRes]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      const dataCode = error?.data?.data?.code;
    }
  };

  return (
    <div>
      <div className="add-account" onClick={onDownloadUsers}>
        <div className="round">
          <i className="eva  eva-download-outline"></i>
        </div>
      </div>
      <div>
        <Table
          autoHeight
          data={accounts?.businessUsers}
          bordered
          cellBordered
          className="admin-table"
        >
          <Column width={getWidth(4)}>
            <HeaderCell>{t('admin.users.email')}</HeaderCell>
            <Cell dataKey="email" />
          </Column>

          <Column width={getWidth(4)}>
            <HeaderCell>{t('admin.users.name')}</HeaderCell>
            <Cell dataKey="name" />
          </Column>

          <Column width={getWidth(5)}>
            <HeaderCell>{t('admin.users.status')}</HeaderCell>
            <StatusCell dataKey="status" />
          </Column>
          <Column width={getWidth(5)}>
            <HeaderCell>{t('signup.status')}</HeaderCell>
            <Cell dataKey="signUpStatus" />
          </Column>
        </Table>
      </div>
      <div className="pagination-div">
        <span>{t('reports.per.page')}</span>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          layout={['-', 'limit', '|', 'pager']}
          total={accounts?.pagination?.totalRecords}
          limitOptions={[10, 15]}
          limit={limit}
          activePage={page}
          onChangePage={page => {
            pageChange(page);
          }}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </div>
  );
}
export default UsersList;
